import type { TmWrappers } from '@/wrappers'
import type { IconSize } from '@/components/shared/types'
import type { IconName } from '@/assets/icons/icons'

export const editSmsSurveyNameModalId: TmWrappers = 'editSmsSurveyName'
export const scheduleSmsSurveyModalId: TmWrappers = 'scheduleSmsSurvey'
export const previewSmsSurveyModalId: TmWrappers = 'previewSmsSurvey'
export const questionSmsSurveyModalId: TmWrappers = 'smsSurveyQuestion'
export const questionDelaySmsSurveyModalId: TmWrappers = 'smsSurveyQuestionDelay'
export const replySmsSurveyModalId: TmWrappers = 'smsSurveyReply'
export const smsSurveyFinalMessageModalId: TmWrappers = 'smsSurveyFinalMessage'

export type SmsSurveyGraphItemTypeName = 'question' | 'reply' | 'delay'

export type SmsSurveyGraphDropdownType = {
  icon: IconName
  label: string
  onClick?: () => void | Promise<void | unknown>
}

export type SmsSurveyGraphItemRepresentItem = {
  fontClass: string
  icon: {
    name: IconName
    size: IconSize
  }
}
